export function formValidate(values) {
  const errors = {};
  if (!values.text && !values.gif?.fixed_width?.url && !values.video) errors.video = 'Enter at least one value';
  if (values.chatOptions?.shareToChat && !values.chatOptions?.channel) errors.channel = 'Select channel';
  if (values.isPublic === null) errors.channel = 'Select public / private';
  return errors;
}
